module.exports = __webpack_public_path__ + "static/media/areas03M.7858bc9d.jpg";